import RouteBase from "routes/RouteBase";
import Layout from "./Layout";

const Root = (props) => <RouteBase {...props} renderRoute={(p) => <Layout {...p} />} />;

export default Root;
